import { clearErpAuthState } from "../erpClient";

export const performAppSignOut = (navigate) => {
  clearErpAuthState();
  localStorage.removeItem("token");
  localStorage.removeItem("api_token");
  localStorage.removeItem("userPermissions");
  localStorage.removeItem("userData");
  localStorage.removeItem("keepLoggedIn");
  localStorage.removeItem("layoutType");
  localStorage.removeItem("currentModule");
  localStorage.removeItem("buttonTableStyle");
  localStorage.removeItem("currentPinType");
  localStorage.removeItem("accessPinModalState");
  localStorage.removeItem("accessPinModalReason");
  navigate("/login");
};
